import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Tr from '../../../../components/common-table/components/Tr';
import { ICONS } from '../../../../icons';
import Td from '../../../../components/common-table/components/Td';
import CommonIconButton from '../../../../components/common-icon-button/CommonIconButton';
import CommonCheckbox from '../../../../components/common-checkbox/CommonCheckbox';
import { USER_ROLES } from '../../../../constants';
import CircleCounter from '../../../../components/circle-counter/CircleCounter';
import { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';
import CommonButtonLink from '../../../../components/common-button-link/CommonButtonLink';

import scss from './UsersTable.module.scss';

const UsersTableItem = ({ user, onDelete, onEnable, onAdminCheck, onChangeProjects }) => {
  const { username, firstName, lastName, enabled, roleName, assignedProjects } = user;

  const { t } = useTranslation('customers');

  const handleDelete = useCallback(() => {
    onDelete(user);
  }, [onDelete, user]);

  const handleEnable = useCallback(() => {
    onEnable(user);
  }, [onEnable, user]);

  const handleAdminCheck = useCallback(() => {
    onAdminCheck(user);
  }, [onAdminCheck, user]);

  const handleChangeProjects = useCallback(() => {
    onChangeProjects(user);
  }, [onChangeProjects, user]);

  return (
    <Tr>
      <Td isLeft>
        <span className={scss.cellName}>{username}</span>
      </Td>
      <Td isLeft>{`${firstName} ${lastName}`}</Td>
      <Td isLeft extraClasses={scss.cellProjects}>
        <CommonButtonLink styleColor={BUTTON_STYLES.SECONDARY} onClick={handleChangeProjects} type='button'>
          {t('projects')}
        </CommonButtonLink>

        <CircleCounter count={assignedProjects.length} />
      </Td>
      <Td extraClasses={scss.cellEnable}>
        <CommonCheckbox checked={enabled} onChange={handleEnable} />
      </Td>
      <Td extraClasses={scss.cellEnable}>
        <CommonCheckbox checked={roleName === USER_ROLES.COMPANY_ADMIN} onChange={handleAdminCheck} />
      </Td>
      <Td extraClasses={scss.cellActions}>
        <CommonIconButton icon={ICONS.Delete} onClick={handleDelete} />
      </Td>
    </Tr>
  );
};

export default UsersTableItem;
